function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0.8437,0,0,0.8437,-8343.18,-197.565)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10180,788.861C10187.1,788.861 10192.8,794.599 10192.8,801.667C10192.8,808.735 10187.1,814.473 10180,814.473C10172.9,814.473 10167.2,808.735 10167.2,801.667C10167.2,794.599 10172.9,788.861 10180,788.861ZM10180,805.781C10181.1,805.781 10181.9,806.651 10181.9,807.723C10181.9,808.794 10181.1,809.664 10180,809.664C10178.9,809.664 10178.1,808.794 10178.1,807.723C10178.1,806.651 10178.9,805.781 10180,805.781ZM10180,793.67C10181.3,793.67 10182.3,793.584 10182.3,797.211C10182.3,800.115 10181.3,804.191 10180,804.191C10178.7,804.191 10177.7,800.115 10177.7,797.211C10177.7,793.721 10178.7,793.67 10180,793.67Z"
}));
function SvgIcnExclamationBallSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-6182,-2040)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,5949.27,1574.81)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-6214.44,-1674.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6460.13,
    cy: 2153.55,
    r: 12.806,
    style: {
      fill: "white"
    }
  })), _ref2)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnExclamationBallSmall);
export default __webpack_public_path__ + "static/media/icn-exclamation-ball-small.407ec00703c2f9b2fc2a54ffb21d7c11.svg";
export { ForwardRef as ReactComponent };